module.exports = __webpack_public_path__ + "static/media/registration-bottom-blob-green.3b5ac353.svg";